<ng-container *ngIf="vcLargeThumbnailEnabled !== undefined">
  <div class="variant-selector" #hasVariantList>
    <div class="variant-name">{{ title }}</div>

    <div *ngIf="isPdpAllVvcEnable" class="selector-wrapper" [class.selector-colors]="isColors(finalVariants)">
      <ul
        class="selector"
        [class.colors]="isColors(finalVariants)"
        [ngClass]="{
          colors: title == 'Colour',
          sizes: title == 'Size',
          ulLargeThumbnail: largeThumbnailEnabled()
        }"
      >
        <ng-container *ngFor="let variant of finalVariants">
          <li
            *ngIf="firstSelector; else otherSelector"
            [ngClass]="{
              selected: variant.variantSelected,
              color: variant.hasImage,
              liLargeThumbnail: largeThumbnailEnabled(),
              size: !variant.hasImage && !largeThumbnailEnabled(),
              availableVVC: !variant.available
            }"
            [class.vvcEnabled]="isPdpAllVvcEnable"
            [class.outStockVVC]="
              (product?.stock?.stockLevelStatus == 'outOfStock' && variant.code == product.code) ||
              variant?.option?.stock?.stockLevelStatus == 'outOfStock' ||
              (product?.stock?.stockLevelStatus === 'discontinued' && variant.code == product.code) ||
              variant?.option?.stock?.stockLevelStatus === 'discontinued'
            "
            [class.out-stock]="
              (product?.stock?.stockLevelStatus == 'outOfStock' && variant.code == product.code) ||
              variant?.option?.stock?.stockLevelStatus == 'outOfStock'
            "
            [class.backorder-stock]="
              (product?.stock?.stockLevelStatus == 'backorder' &&
                product?.stock?.stockLevel < 1 &&
                variant.code == product.code) ||
              (variant?.option?.stock?.stockLevelStatus == 'backorder' &&
                variant?.option?.stock?.stockLevel < 1 &&
                variant.available)
            "
            [class.discontinued-stock]="
              (product?.stock?.stockLevelStatus === 'discontinued' && variant.code == product.code) ||
              variant?.option?.stock?.stockLevelStatus === 'discontinued'
            "
            (click)="changeSize(variant.code, variant.variantSelected)"
          >
            <cx-media
              *ngIf="variant.hasImage"
              matTooltip="{{ variant?.name }}"
              [matTooltipPosition]="'below'"
              matTooltipClass="image-tooltip"
              aria-label="Image that displays a tooltip in bottom"
              [alt]="variant?.name"
              [container]="getImageRendition(variant.variantOptionQualifiers[0].image)"
              [class.is-missing-fish]="businessType === 'fish'"
            ></cx-media>
            {{ variant.hasImage ? '' : variant.name }}
          </li>
          <ng-template #otherSelector>
            <li
              [ngClass]="{
                selected: variant.variantSelected,
                color: variant.hasImage,
                size: !variant.hasImage,
                liLargeThumbnail: largeThumbnailEnabled(),
                size: !variant.hasImage && !largeThumbnailEnabled(),
                availableVVC: !variant.available
              }"
              [class.vvcEnabled]="isPdpAllVvcEnable"
              [class.outStockVVC]="
                (product?.stock?.stockLevelStatus == 'outOfStock' && variant.code == product.code) ||
                variant?.option?.stock?.stockLevelStatus == 'outOfStock' ||
                (product?.stock?.stockLevelStatus === 'discontinued' && variant.code == product.code) ||
                variant?.option?.stock?.stockLevelStatus === 'discontinued'
              "
              [class.out-stock]="
                (product?.stock?.stockLevelStatus == 'outOfStock' && variant.code == product.code) ||
                variant?.option?.stock?.stockLevelStatus == 'outOfStock'
              "
              [class.backorder-stock]="
                (product?.stock?.stockLevelStatus == 'backorder' &&
                  product?.stock?.stockLevel < 1 &&
                  variant.code == product.code) ||
                (variant?.option?.stock?.stockLevelStatus == 'backorder' &&
                  variant?.option?.stock?.stockLevel < 1 &&
                  variant.available)
              "
              [class.discontinued-stock]="
                (product?.stock?.stockLevelStatus === 'discontinued' && variant.code == product.code) ||
                variant?.option?.stock?.stockLevelStatus === 'discontinued'
              "
              (click)="changeSize(variant.code, variant.variantSelected)"
            >
              <cx-media
                *ngIf="variant.hasImage"
                matTooltip="{{ variant?.name }}"
                [matTooltipPosition]="'below'"
                matTooltipClass="image-tooltip"
                aria-label="Image that displays a tooltip in bottom"
                [alt]="variant?.name"
                [container]="getImageRendition(variant.variantOptionQualifiers[0].image)"
                [class.is-missing-fish]="businessType === 'fish'"
              ></cx-media>
              {{ variant.hasImage ? '' : variant.name }}
            </li>
          </ng-template>
        </ng-container>
      </ul>
    </div>

    <div *ngIf="!isPdpAllVvcEnable" class="selector-wrapper" [class.selector-colors]="isColors(variants)">
      <ul
        class="selector"
        [class.colors]="isColors(variants)"
        [ngClass]="{
          colors: title == 'Colour',
          sizes: title == 'Size',
          ulLargeThumbnail: largeThumbnailEnabled()
        }"
      >
        <ng-container *ngFor="let variant of variants">
          <li
            *ngIf="firstSelector; else otherSelector"
            [ngClass]="{
              selected: variant.variantSelected,
              color: variant.hasImage,
              liLargeThumbnail: largeThumbnailEnabled(),
              size: !variant.hasImage && !largeThumbnailEnabled()
            }"
            [class.out-stock]="
              (product?.stock?.stockLevelStatus == 'outOfStock' && variant.code == product.code) ||
              variant?.option?.stock?.stockLevelStatus == 'outOfStock'
            "
            [class.backorder-stock]="
              (product?.stock?.stockLevelStatus == 'backorder' &&
                product?.stock?.stockLevel < 1 &&
                variant.code == product.code) ||
              (variant?.option?.stock?.stockLevelStatus == 'backorder' && variant?.option?.stock?.stockLevel < 1)
            "
            [class.discontinued-stock]="
              (product?.stock?.stockLevelStatus === 'discontinued' && variant.code == product.code) ||
              variant?.option?.stock?.stockLevelStatus === 'discontinued'
            "
            (click)="changeSize(variant.code, variant.variantSelected)"
          >
            <cx-media
              *ngIf="variant.hasImage"
              matTooltip="{{ variant?.name }}"
              [matTooltipPosition]="'below'"
              matTooltipClass="image-tooltip"
              aria-label="Image that displays a tooltip in bottom"
              [alt]="variant?.name"
              [container]="getImageRendition(variant.variantOptionQualifiers[0].image)"
              [class.is-missing-fish]="businessType === 'fish'"
            ></cx-media>
            {{ variant.hasImage ? '' : variant.name }}
          </li>
          <ng-template #otherSelector>
            <li
              *ngIf="showProductSelectedVariant(variant.categorySelected, variant.prevCategory)"
              [ngClass]="{
                selected: variant.variantSelected,
                color: variant.hasImage,
                liLargeThumbnail: largeThumbnailEnabled(),
                size: !variant.hasImage && !largeThumbnailEnabled()
              }"
              [class.out-stock]="
                (product?.stock?.stockLevelStatus == 'outOfStock' && variant.code == product.code) ||
                variant?.option?.stock?.stockLevelStatus == 'outOfStock'
              "
              [class.backorder-stock]="
                (product?.stock?.stockLevelStatus == 'backorder' &&
                  product?.stock?.stockLevel < 1 &&
                  variant.code == product.code) ||
                (variant?.option?.stock?.stockLevelStatus == 'backorder' && variant?.option?.stock?.stockLevel < 1)
              "
              [class.discontinued-stock]="
                (product?.stock?.stockLevelStatus === 'discontinued' && variant.code == product.code) ||
                variant?.option?.stock?.stockLevelStatus === 'discontinued'
              "
              (click)="changeSize(variant.code, variant.variantSelected)"
            >
              <cx-media
                *ngIf="variant.hasImage"
                matTooltip="{{ variant?.name }}"
                [matTooltipPosition]="'below'"
                matTooltipClass="image-tooltip"
                aria-label="Image that displays a tooltip in bottom"
                [alt]="variant?.name"
                [container]="getImageRendition(variant.variantOptionQualifiers[0].image)"
                [class.is-missing-fish]="businessType === 'fish'"
              ></cx-media>
              {{ variant.hasImage ? '' : variant.name }}
            </li>
          </ng-template>
        </ng-container>
      </ul>
    </div>
  </div>
</ng-container>
